import React, { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import MinimalLoader from './MinimalLoader';
import CursorTrail from './CursorTrail';
import ResumePage from './ResumePage';

const Scene3D = React.lazy(() => import('./Scene3D'));

export default function App() {
  const [showApp, setShowApp] = useState(false);
  const [lang, setLang] = useState('en');
  // Restore saved theme (ResumePage persists it to localStorage)
  const [theme, setTheme] = useState(() => {
    try {
      const saved = localStorage.getItem('theme');
      return saved === 'light' || saved === 'dark' ? saved : 'dark';
    } catch {
      return 'dark';
    }
  });
  const scrollContainerRef = useRef(null);

  const isDark = theme === 'dark';

  return (
    <div className="relative min-h-screen overflow-hidden bg-black">
      <AnimatePresence mode="wait">
        {!showApp ? (
          <MinimalLoader
            key="loader"
            onFinish={() => setShowApp(true)}
          />
        ) : (
          <motion.div
            key="app-main"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            className="fixed inset-0 overflow-hidden transform-gpu"
          >
            {/* Background Layer */}
            <React.Suspense fallback={null}>
              <Scene3D isDark={isDark} />
            </React.Suspense>
            <CursorTrail isDark={isDark} />

            {/* Content */}
            <div ref={scrollContainerRef} className="absolute inset-0 z-10 overflow-y-auto scroll-smooth">
              <ResumePage
                lang={lang}
                setLang={setLang}
                theme={theme}
                setTheme={setTheme}
                scrollContainerRef={scrollContainerRef}
              />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
